import angular from 'angular';

import CardWithYearPickerComponent from './card-with-year-picker.cmpt';

export default angular
    .module('application.scene.authorized.scene.dashboard.component.card-with-year-picker', [])
    .component(CardWithYearPickerComponent.selector, CardWithYearPickerComponent);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/dashboard/component/card-with-year-picker/index.js